export const getBrowserLanguages = (_window = window) => {
    const languages = _window.navigator.languages;
    if (languages && languages.length > 0 && Array.isArray(languages)) {
        return languages.join(',');
    }

    const language = _window.navigator.language;
    return language || '';
};
